import _ from 'lodash';
import { HTTP_UNAVAILABLE } from '../constants/http.constants';
import { BFF_HOST } from '../constants/settings.constants';
import { getToken } from './session.storage';

export async function apiRequest(method, url, options = { skipToken: false, body: {} }) {
  const HOST = options.host || BFF_HOST[process.env.REACT_APP_SPO_ENV] || '';
  let status;
  try {
    const request = await window.fetch(`${HOST}${url}`, {
      headers: _headers(options.skipToken),
      method: method,
      mode: 'cors',
      body: !_.isEmpty(options.body) ? JSON.stringify(options.body) : undefined
    });
    status = await request.status;
    const json = await request.json();
    return { status, json };
  } catch (e) {
    return { status: status || HTTP_UNAVAILABLE, json: { message: 'Service Unavailable' } };
  }
}

function _headers(skipToken) {
  const defaultHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };
  const authorization = skipToken ? {} : { Authorization: `Bearer ${getToken()}` };
  return { ...defaultHeaders, ...authorization };
}

export async function apiFormRequest(method, url, formBody, options = {}) {
  var data = new FormData();
  _.forEach(formBody, (v, k) => {
    if (options.multipleFilesKey && k === options.multipleFilesKey) {
      v.forEach((file) => {
        data.append(options.multipleFilesKey, file);
      });
    } else {
      data.append(k, Array.isArray(v) ? JSON.stringify(v) : v);
    }
  });
  let status;
  try {
    const request = await fetch((options.host || BFF_HOST[process.env.REACT_APP_SPO_ENV] || '') + url, {
      method: method,
      headers: {
        Authorization: `Bearer ${getToken()}`
      },
      body: data
    });
    status = await request.status;
    let json = {};
    try {
      json = await request.json();
    } catch (e) {
      json = {};
    }
    return { status, json: json };
  } catch (e) {
    return { status: HTTP_UNAVAILABLE, json: { message: 'Service Unavailable' } };
  }
}
